import React from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';
export type IconPosition = 'left' | 'right';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  block?: boolean;
  icon?: string | React.ReactNode;
  iconPosition?: IconPosition;
  iconOnly?: boolean;
  children?: React.ReactNode;
}

/**
 * KERN Button Component
 *
 * Usage:
 * <Button variant="primary">Primary Button</Button>
 * <Button variant="secondary" icon="edit" iconPosition="left">Edit</Button>
 * <Button variant="tertiary" icon="delete" iconOnly>Delete</Button>
 */
export function Button({
  variant = 'primary',
  block = false,
  icon,
  iconPosition = 'left',
  iconOnly = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const classes = ['kern-btn', `kern-btn--${variant}`, block && 'kern-btn--block', className]
    .filter(Boolean)
    .join(' ');

  const iconElement =
    icon &&
    (typeof icon === 'string' ? (
      <span className={`kern-icon kern-icon--${icon}`} aria-hidden="true" />
    ) : (
      icon
    ));

  return (
    <button className={classes} type="button" {...props}>
      {icon && iconPosition === 'left' && iconElement}
      <span className={iconOnly ? 'kern-label kern-sr-only' : 'kern-label'}>{children}</span>
      {icon && iconPosition === 'right' && iconElement}
    </button>
  );
}

export default Button;
